import React from "react";
import { Line } from "react-chartjs-2";
import { MDBContainer } from "mdbreact";

class DashboardLineGraph extends React.Component {
    constructor(props) {
        super()
    }

    render() {
        let dataLine = {
            labels: this.props.graphData.labels,
                datasets: [
                    {
                        label: "Curr. Year",
                        fill: true,
                        lineTension: 0.3,
                        backgroundColor: "rgba(225, 204,230, .3)",
                        borderColor: "rgb(227, 3, 133)",
                        borderCapStyle: "butt",
                        borderDash: [],
                        borderDashOffset: 0.0,
                        borderJoinStyle: "miter",
                        pointBorderColor: "rgb(103, 31, 117)",
                        pointBackgroundColor: "rgb(255, 255, 255)",
                        pointBorderWidth: 5,
                        pointHoverRadius: 5,
                        pointHoverBackgroundColor: "rgb(0, 0, 0)",
                        pointHoverBorderColor: "rgba(220, 220, 220,1)",
                        pointHoverBorderWidth: 2,
                        pointRadius: 1,
                        pointHitRadius: 10,
                        data: this.props.graphData.currYTDSales
                    },
                    {
                        label: "Prev. Year",
                        fill: false,
                        lineTension: 0.3,
                        backgroundColor: "rgba(184, 185, 210, .3)",
                        borderColor: "rgb(216, 216, 216)",
                        borderCapStyle: "butt",
                        borderDash: [],
                        borderDashOffset: 0.0,
                        borderJoinStyle: "miter",
                        pointBorderColor: "rgb(150, 150, 150)",
                        pointBackgroundColor: "rgb(255, 255, 255)",
                        pointBorderWidth: 5,
                        pointHoverRadius: 5,
                        pointHoverBackgroundColor: "rgb(0, 0, 0)",
                        pointHoverBorderColor: "rgba(220, 220, 220, 1)",
                        pointHoverBorderWidth: 2,
                        pointRadius: 1,
                        pointHitRadius: 10,
                        data: this.props.graphData.prevYTDSales
                    }
                ]
        }
        return (
            <MDBContainer>
                <h3 className="mt-5">{this.props.chartName}</h3>
                <Line data={dataLine} options={{ responsive: true }} />
            </MDBContainer>
        );
    }
}

export default DashboardLineGraph;